import React from 'react';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';
import { ConnectionState } from '../types';

interface ConnectionStatusProps {
  connectionState: ConnectionState;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ connectionState }) => {
  const getStatusIcon = () => {
    if (connectionState.isConnecting) {
      return <Loader2 className="w-4 h-4 animate-spin" />;
    }
    if (connectionState.isConnected) {
      return <Wifi className="w-4 h-4 text-green-600" />;
    }
    return <WifiOff className="w-4 h-4 text-red-600" />;
  };

  const getStatusText = () => {
    if (connectionState.isConnecting) return 'Connecting...';
    if (connectionState.isConnected) return 'Connected';
    if (connectionState.error) return `Disconnected: ${connectionState.error}`;
    return 'Disconnected';
  };

  return (
    <div 
      data-component="ConnectionStatus" 
      className="flex items-center px-2 py-1 bg-gray-50 rounded-full cursor-help"
      title={getStatusText()}
    >
      {getStatusIcon()}
    </div>
  );
};